import React from "react";
import "./Purpose.css";
import Slider from "../SliderComp/Slider";

// Import images
import twoImg1 from "./two.jpeg";
import twoImg2 from "./IMG_0868.jpg";
import twoImg3 from "./IMG_2981.jpg";
import threeImg1 from "./three.jpeg";
import threeImg2 from "./image5.jpg";
import threeImg3 from "./image6.jpg";
import image5 from "./image5.jpg";
import image6 from "./image6.jpg";
import image7 from "./image7.jpg";

const Purpose = () => {
  // Image decks for each section
  const selfDefenseImages = [twoImg1, twoImg2, twoImg3];
  const fitnessImages = [threeImg1, threeImg2, threeImg3];
  const concentrationImages = [image5, image6, image7];

  return (
    <div className="purpose-page">
      <h1 className="page-heading">Purpose</h1>

      {/* Self Defence Section */}
      <div className="row">
        <div className="slider-container">
          <Slider images={selfDefenseImages} />
        </div>
        <div className="text-container">
          <h2>Self Defence</h2>
          <p>
          SoIK is rooted in Kalaripayattu, an ancient and revered Indian martial art often called the “Mother of All Martial Arts.” 
          Originating in India, Kalaripayattu emphasizes high standards of physical fitness, mental focus, and agility, making it a comprehensive system for practical self-defense.
          </p>
        </div>
      </div>

      {/* Fitness Training Section */}
      <div className="row-reverse">
        <div className="text-container">
          <h2>Fitness Training</h2>
          <p>
            Children and adults of all ages require more than a regular school and
            college education for an all-round development. A healthy lifestyle requires
            good fitness levels. To this end, SoIK focuses on an optimal exercise regime
            designed to enhance physical fitness.
          </p>
        </div>
        <div className="slider-container">
          <Slider images={fitnessImages} />
        </div>
      </div>

      {/* Concentration and discipline development Section */}
        <div className="row">
          <div className="slider-container">
            <Slider images={selfDefenseImages} />
          </div>
          <div className="text-container">
            <h2>Concentration and discipline development</h2>
            <p>
              Karate helps improve powers of concentration in students enrolled with the school through yoga based medidation techniques. Students are taught to be respectful to their seniors and their instructors.SoIKs foremost goal is to strenghthen the mind as much as it does the body.
            </p>
          </div>
        </div>

    </div>
  );
};

export default Purpose;